import * as am4charts from "@amcharts/amcharts4/charts";

import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Button from "@material-ui/core/es/Button/Button";
import * as moment from "moment";
import * as Pikaday from "pikaday";
import React from "react";
import {Link} from "react-router-component";

import ActionBar from "../components/ActionBar";
import AlertDialog from "../components/AlertDialog";
import Loader from "../components/Loader";
import PopupImage from "../components/PopupImage";
import VLButton from "../components/VLButton";
import * as API from "../util/api";
import * as Provider from "../util/provider";
import * as Render from "../util/Render";
import * as Util from "../util/util";
import PopupStatsGraph from "./PopupStatsGraph";
import VLComponent from "./VLComponent";

am4core.useTheme(am4themes_animated);

export default class GraphScreen extends VLComponent {

    constructor() {
        super();
        this.fromInput = React.createRef();
        this.toInput = React.createRef();
        this.state = {loaded: false, graph_data: [], sensor_name: "", showingInfo: true};
    }

    provider = () => {
        if (!this.props.provider) {
            return Provider.VL;
        }
        return this.props.provider;
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.id != this.props.id) {
            this.fetch();
        }
    }

    componentDidMount() {
        let dom = this;
        let picker = new Pikaday({
            field: this.fromInput.current,
            format: "DD/MM/YY",

            onSelect: function (date) {
                let event = {
                    target: {
                        name: "dateFrom",
                        value: picker.toString()
                    }
                };
                dom.handleInputChange(event);
            }
        });

        let picker2 = new Pikaday({
            field: this.toInput.current,
            format: "DD/MM/YY",

            onSelect: function (date) {
                let event = {
                    target: {
                        name: "dateTo",
                        value: picker2.toString()
                    }
                };
                dom.handleInputChange(event);
            }
        });

        am4core.options.commercialLicense = true;
        let chart = am4core.create("chartdiv", am4charts.XYChart);


        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.dateFormats.setKey("hour", "dd MMM HH:mm");
        dateAxis.periodChangeDateFormats.setKey("hour", "dd MMM HH:mm");
        dateAxis.dateFormats.setKey("minute", "dd MMM HH:mm");
        dateAxis.periodChangeDateFormats.setKey("minute", "dd MMM HH:mm");
        dateAxis.dateFormats.setKey("day", "dd MMM yyyy");
        dateAxis.periodChangeDateFormats.setKey("day", "dd MMM yyyy");
        dateAxis.dateFormats.setKey("week", "dd MMM yyyy");
        dateAxis.periodChangeDateFormats.setKey("week", "dd MMM yyyy");
        dateAxis.dateFormats.setKey("month", "MMM yyyy");
        dateAxis.periodChangeDateFormats.setKey("month", "MMM yyyy");

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        this.valueAxis = valueAxis;

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "date";
        series.dataFields.valueY = "value";
        series.fill = am4core.color(window.primary);

        series.tooltipText = "{dateX.formatDate('dd/MM/yyyy')}: {valueY.value}cm";
        series.tooltip.pointerOrientation = "vertical";
        series.tooltipHTML = "<span style='color: white'>{dateX.formatDate('dd/MM/yyyy')}: {valueY.value}cm<br/><i>Click to view image</i></span>";
        if (!this.isVL()) {
            series.tooltipHTML = "<span style='color: white'>{dateX.formatDate('dd/MM/yyyy')}: {valueY.value}cm</span>";
        }
        chart.cursor = new am4charts.XYCursor();

        chart.interactionsEnabled = true;

        chart.events.on("hit", this.fetchImage, this);

        chart.cursor.events.on("cursorpositionchanged", (ev) => {
            let xAxis = ev.target.chart.xAxes.getIndex(0);
            let date = xAxis.positionToDate(xAxis.toAxisPosition(ev.target.xPosition));
            console.log(date);
            this.hoveredDate = (date);
        });

        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        chart.scrollbarX = scrollbarX;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = this.state.sensor_name;
        this.chart = chart;

        this.fetch();
    }

    fetchImage = () => {
        if (!this.isVL()) {
            return;
        }
        this.setState({viewingUrl: "loading"});
        let time = this.hoveredDate.getTime() / 1000;
        API.POST("systems/bestImage", {time: time, sensor_id: this.state.sensor_id}, result => {
            let src = result.result.image;
            this.requireImage(src, () => {
                this.setState({viewingUrl: src});
            });
        });
    };

    addLine = (level, label, color) => {
        let line = this.valueAxis.axisRanges.create();
        line.value = level;
        line.grid.stroke = am4core.color(color);
        line.grid.strokeWidth = 1;
        line.grid.strokeOpacity = 0.6;
        line.label.inside = true;
        line.label.dy = -10;
        line.label.align = "right";
        line.label.text = label;
    };

    fetch = () => {
        this.setState({loaded: false});
        let endpoint = "systems/list";
        let params = {sensor_id: this.props.id};
        if (Util.isCommunity()) {
            endpoint = "systems/communityList";
        }
        if (this.props.provider == "ea") {
            endpoint = "systems/getEa";
        }
        if (this.props.provider == "nrw") {
            endpoint = "systems/getNrw";
        }
        API.POST(endpoint, params, result => {
            Util.handleLogout(result);
            if (result.success) {
                let sensor = result.result.sensors[0];
                sensor.new_system_text = sensor.system_text || "";
                //check for hi res
                if (sensor.outstation_type == 3) {
                    let orig = sensor;
                    sensor = sensor.hi_res_sensor;
                    sensor.sensor_image = orig.sensor_image;
                    sensor.sensor_comms = orig.sensor_comms;
                    sensor.sensor_comms_unix = orig.sensor_comms_unix;
                    sensor.sensor_name = orig.sensor_name + " High Res";
                    sensor.sensor_id = orig.sensor_id;
                    this.setState({hiRes: true});
                }
                this.setState(sensor, this.setupGraph);

                let link = "/sensor/" + sensor.sensor_id;
                if (this.props.provider != Provider.VL && this.props.provider != null) {
                    link = "/sensor/" + this.props.provider + "/" + sensor.sensor_id;
                }
                Util.logHistory(sensor.sensor_name, link);


                if (this.isVL()) {
                    const {alert_level, act_con_level, warning_level, smartphone_warning} = this.state;
                    if (!Util.isCommunity()) {
                        if (this.state.fido_alarms_en) {
                            if (alert_level > 0) {
                                this.addLine(alert_level, Util.alertLevelName() + " Level", "#ff0000");
                            }
                            if (act_con_level > 0) {
                                this.addLine(act_con_level, Util.actConLevelName() + " Level", "#ff0000");
                            }
                        }
                        if (this.state.smartphone_warning_en && smartphone_warning != 0) {
                            this.addLine(smartphone_warning, "Smartphone Level", "#ff0000");
                        }
                    }
                    if ((this.state.fido_alarms_en || this.provider() != Provider.VL) && warning_level > 0) {
                        this.addLine(warning_level, Util.warningLevelName() + " Level", "#ff0000");
                    }
                } else {
                    this.addLine(this.state.warning_level, "Typical High", "#ff0000");
                    //this.addLine(this.state.warning_level, "Typical Low", '#ff0000');
                }

                setTimeout(() => {
                    this.chart.exporting.filePrefix = this.state.sensor_name;
                    this.setState({loaded: true});
                }, 500);
            }
        });
    };

    viewPeak = () => {
        this.setState({loaded: false});
        API.POST("systems/graph", {peak: true, sensor_id: this.state.sensor_id}, result => {
            if (result.success) {
                this.setState({graph_data: result.result.graph_data, loaded: true}, this.setupGraph);
            }
        });
    };

    fetchLevels = () => {
        let from = this.state.dateFrom;
        let to = this.state.dateTo;
        from = (moment(from, "DD/MM/YY").unix());
        to = (moment(to, "DD/MM/YY").unix());
        if (from == 0 || from == null || from == "" || isNaN(from) || to == 0 || to == null || to == "" || isNaN(to) || from > to) {
            this.basicAlert("Invalid dates");
            return;
        }
        API.POST("systems/graph", {start: from, end: to, sensor_id: this.state.sensor_id}, result => {
            if (result.success) {
                this.setState({graph_data: result.result.graph_data}, this.setupGraph);
            }
        });
    };

    setupGraph = () => {
        let data = [];
        this.state.graph_data.forEach(datum => {
            data.push({date: new Date(datum.timestamp * 1000), name: "", value: datum.level});
        });
        this.chart.data = data;
    };

    editAlert = () => {
        return <div style={{width: "100%", display: "flex", flexDirection: "column", alignItems: "stretch"}}>
            {this.editButtons()}
        </div>;
    };

    editButtons = () => {
        let id = this.state.sensor_id;
        let b = [<Button color="primary" component={Link} href={"/edit/" + id}>Edit Sensor Details</Button>];
        if (!this.state.hiRes) {
            b = b.concat([
                <Button color="primary" component={Link} href={"/inputs/" + id}>Edit Sensor Inputs</Button>
            ]);
        }
        b = b.concat([
            <Button color="primary" component={Link} href={"/levels/" + id}>Edit Sensor Levels</Button>,
            <Button color="primary" onClick={() => this.setState({editingText: true})}>Edit Sensor Text</Button>,
            <Button color="primary" onClick={() => this.setState({editOpen: false})}>Cancel</Button>
        ]);
        return b;
    };

    textEditor = () => {
        return <div>
            <textarea style={{width: "100%", height: 500, maxHeight: "calc(100vh - 300px)"}}
                      value={this.state.new_system_text} name="new_system_text" onChange={this.handleInputChange}
                      className="vl-input"/>
        </div>;
    };

    saveText = (doSave) => {
        if (doSave) {
            this.setState({loaded: false});
            API.POST("systems/setText", {sensor_id: this.state.sensor_id, text: this.state.new_system_text}, result => {
                if (result.success) {
                    this.fetch();
                } else {
                    this.setState({loaded: true});
                    this.basicAlert(result.error);
                }
            });
        }
        this.setState({editingText: false, editOpen: false});
    };

    render() {
        return (
            <div>
                {this.state.viewing_stats &&
                <PopupStatsGraph camera_id={this.state.sensor_id} navigate={this.props.navigate} close={() => {
                    this.setState({viewing_stats: false});
                }}/>
                }
                {this.renderTextAlert()}
                <AlertDialog title="Edit" open={this.state.editOpen} content={this.editAlert}/>

                <AlertDialog title="Sensor Text" positive="Save" negative="Cancel" content={this.textEditor}
                             action={this.saveText}
                             open={this.state.editingText}/>

                <ActionBar title={"Level Sensor Graph - " + this.state.sensor_name}/>
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    padding: 24,
                    flexDirection: "column",
                    overflowY: "auto",
                    height: "calc(100vh - 56px)"
                }}>
                    {this.renderDateChooser()}
                    <div id="chartdiv" ref={this.graphRef}
                         style={{width: "100%", flex: 1}}/>
                    <div style={{display: this.state.showingInfo ? "flex" : "none", flexWrap: "wrap"}}>
                        {this.renderInfo()}
                        {this.renderText()}
                    </div>

                    {this.state.viewingUrl &&
                    <PopupImage url={this.state.viewingUrl} close={() => this.setState({viewingUrl: ""})}/>}
                </div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

    renderDateChooser = () => {
        return (
            <div style={{display: "flex", width: "100%"}}>
                <div style={{display: (!Util.isCommunity() && this.isVL()) ? "flex" : "none"}}>
                    <p>From: </p>
                    <input style={{width: 100}} className="vl-input" readOnly ref={this.fromInput}/>
                    <p>To: </p>
                    <input style={{width: 100}} className="vl-input" readOnly ref={this.toInput}/>
                    <VLButton style={{marginLeft: 8}} title="GO" onClick={this.fetchLevels}/>
                </div>

                <div style={{flex: 1}}/>

                <VLButton title="Sensor Info" onClick={() => this.setState({showingInfo: !this.state.showingInfo})}/>

                <div className="dropdown"
                     style={{marginLeft: 8, display: Render.iff(this.isVL() && !Util.isCommunity())}}>
                    <VLButton style={{height: 40}} className="dropbtn" title="Jump"/>
                    <div className="dropdown-content" style={{textAlign: "left"}}>
                        <button onClick={this.viewPeak} className="w3-button w3-white wide">Peak Level</button>
                        <button onClick={this.viewRecent} className="w3-button w3-white wide">Recent</button>
                        <button onClick={this.fullGraph} className="w3-button w3-white wide">Full Graph</button>
                    </div>
                </div>

                <VLButton style={{marginLeft: 8, display: Render.iff(this.isVL())}} title="Image"
                          onClick={() => this.setState({viewingUrl: this.state.sensor_image})}/>
                <VLButton style={{marginLeft: 8, display: Render.iff(this.isVL())}} title="Stats"
                          onClick={this.viewStats}/>
                <VLButton style={{marginLeft: 8, display: Render.iff(!Util.isCommunity() && !Util.isSubAccount())}}
                          title="Map" href={"/map/" + this.state.sensor_id}/>
                <VLButton
                    style={{marginLeft: 8, display: Render.iff(Util.isAdmin() && !Util.isSubAccount() && this.isVL())}}
                    title="Broadcast" href={"/broadcast/" + this.state.sensor_id}/>
                <VLButton
                    style={{marginLeft: 8, display: Render.iff(this.isVL() && Util.isAdmin() && !Util.isSubAccount())}}
                    title="Edit"
                    onClick={() => this.setState({editOpen: true})}/>
            </div>
        );
    };

    viewRecent = () => {
        this.fetch();
    };

    fullGraph = () => {
        this.setState({loaded: false});
        API.POST("systems/graph", {full: true, sensor_id: this.state.sensor_id}, result => {
            if (result.success) {
                this.setState({graph_data: result.result.graph_data, loaded: true}, this.setupGraph);
            }
        });
    };

    anyWarning = () => {
        return this.isWarning() || this.isAboveAlert() || this.isAboveActCon() || this.isAboveCommunityLevel();
    };

    isAboveCommunityLevel = () => {
        return this.state.smartphone_warning_en && this.state.smartphone_warning > 0 && this.state.smartphone_warning < this.state.current_level;
    };

    isWarning = () => {
        return this.state.warning_level < this.state.current_level && this.state.warning_level > 0;
    };

    isAboveAlert = () => {
        return this.state.alert_level < this.state.current_level && this.state.alert_level > 0;
    };

    isAboveActCon = () => {
        return this.state.act_con_level < this.state.current_level && this.state.act_con_level > 0;
    };

    nextUpdateTime = () => {
        return moment.unix(this.state.sensor_comms_unix + this.state.update_rate * 60).format(" HH:mm");
    };

    renderText = () => {
        if (this.state.system_text) {
            let st = {
                borderColor: window.primary,
                borderWidth: 2,
                borderStyle: "solid",
                margin: "16px 8px",
                padding: 12,
                width: "100%",
                textAlign: "center"
            };
            return <div style={st}>{this.state.system_text}</div>;
        }
    };

    typicalRange = () => {
        return Util.round3(this.state.typicalLow) + "m - " + Util.round3(this.state.typicalHigh) + "cm";
    };

    renderInfo = () => {
        let red = "red";
        let green = "green";
        let grey = "#AAAAAA";

        const makeLevelInfo = (name, level, en) => {
            const disabled = (level == 0 || !en);
            const colour = disabled ? grey : level > this.state.current_level ? green : red;
            return {name: name + " Level", colour: colour, value: disabled ? "Disabled" : (level + "cm")};
        };

        if (!this.isVL()) {
            const infos = [
                {name: "Current Level", colour: this.anyWarning() ? red : green, value: this.state.current_level + "cm"},
                {name: "Level Change", colour: green, value: Util.round4(this.state.level_change) + "cm"},
                {name: "Last Updated", colour: grey, value: moment.unix(this.state.sensor_comms_unix).format("d MMM HH:mm")},
                {name: "Updates Every", colour: grey, value: this.state.update_rate + " minutes"},
                {name: "All Time Low", colour: grey, value: Util.round3(this.state.minOnRecord) + "cm"},
                {name: "All Time High", colour: grey, value: Util.round3(this.state.maxOnRecord) + "cm"},
                {name: "River", colour: grey, value: this.state.riverName},
                {name: "Catchment", colour: grey, value: this.state.catchment},
                {name: "Typical Range", colour: grey, value: this.typicalRange()},
                {name: "Date Opened", colour: grey, value: this.state.opened},
                {name: "Max Level (last 24h)", colour: grey, value: Util.round3(this.state.level_max) + "cm"},
                {name: "Average Level (last 24h)", colour: grey, value: Util.round3(this.state.level_avg) + "cm"}
            ];

            return infos.map(e => this.renderInfoItem(e, "25%"));
        }

        const col0 = [
            {name: "Current Level", colour: this.anyWarning() ? red : green, value: this.state.current_level + "cm"},
            {name: "Level Change", colour: green, value: Util.round4(this.state.level_change )+ "cm"},
            makeLevelInfo("Smartphone", this.state.smartphone_warning, this.state.smartphone_warning_en)
        ];

        const col1 = [
            makeLevelInfo(Util.actConLevelName(), this.state.act_con_level, this.state.fido_alarms_en),
            makeLevelInfo(Util.alertLevelName(), this.state.alert_level, this.state.fido_alarms_en),
            makeLevelInfo(Util.warningLevelName(), this.state.warning_level, this.state.fido_alarms_en)
        ];

        const col2 = [
            {name: "Last Updated", colour: grey, value: this.state.sensor_comms},
            {name: "Max Level (last 24h)", colour: grey, value: Util.round3(this.state.level_max) + "cm"},
            {name: "Average Level (last 24h)", colour: grey, value: Util.round3(this.state.level_avg) + "cm"}
        ];

        const col3 = [
            {name: "Updates Every", colour: grey, value: this.state.update_rate + " minutes"},
            {name: "mAOD Level", colour: grey, value: this.state.mAOD == 0 ? "Disabled" : `${this.state.mAOD}cm`},
            {name: "Under Range", colour: grey, value: this.state.under_range + "cm"}
        ];

        //transform to render vertically rather than horizontally
        const transformed = [];
        for (let i = 0; i < 3; i++) {
            transformed.push(col0[i]);
            transformed.push(col1[i]);
            transformed.push(col2[i]);
            transformed.push(col3[i]);
        }

        return transformed.filter(e => e != null).map(e => this.renderInfoItem(e, "25%"));
    };

    renderInfoItem = (info, width) => {
        return (
            <div style={{display: "flex", width}}>
                <p style={{
                    flex: 1,
                    background: info.colour,
                    borderRadius: 16,
                    color: "white",
                    padding: 8,
                    margin: "2px 4px",
                    textAlign: 'center'
                }}>{info.name}: {info.value}</p>
            </div>
        )
    };

    isVL = () => {
        return this.props.provider == Provider.VL || this.props.provider == null;
    };

    viewStats = () => {
        this.setState({viewing_stats: true});
    }

}